export const ChevronDown = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.3647 11.3512L15.9546 20.6488L6.6352 11.3847" stroke="currentColor" stroke-width="2"/>
</svg>`;
